import React from 'react'
import { connect } from 'react-redux'
import _ from 'lodash'
import {
  Button,
  Input,
  Label,
  Icon,
  Menu,
  Loader,
  Grid,
  Form,
  Segment,
  Header,
} from 'semantic-ui-react'
import Select from 'react-select'

import firebase from '../../config/firebase'
import RestaurantActions from '../../reducers/restaurantReducer'

class NewRecommended extends React.Component {
  state = {
    selectedResto: null,
    selectedItems: [],
    itemsLoading: false,
    items: {},
    searchValue: '',
    saving: false,
    recommendedBy: 'editor',
    status: 'draft',
  }

  componentDidMount() {
    const { history, fetchRestaurants, restaurantLoaded } = this.props

    if (!restaurantLoaded) {
      fetchRestaurants()
    }

    if (
      history.location.state &&
      history.location.state.action &&
      history.location.state.action === 'edit'
    ) {
      const resto = history.location.state.restaurant

      this.setState(
        {
          selectedResto: { value: resto.key, label: resto.name },
          selectedItems: _.map(resto.recommended_items, (item, itemKey) => itemKey),
          recommendedBy: resto.show_recommend_items.recommended_by,
          status: resto.show_recommend_items.active ? 'publish' : 'draft',
        },
        () => {
          this.getRestaurantItems()
        }
      )
    }
  }

  getRestaurantItems = () => {
    const { selectedResto, items } = this.state
    const { value: restKey } = selectedResto

    this.setState({ itemsLoading: true })

    firebase
      .database()
      .ref(`items/${restKey}`)
      .once('value', snapshot => {
        const itemSnapshot = snapshot.val()

        this.setState({
          items: {
            ...items,
            [restKey]: itemSnapshot || {},
          },
          itemsLoading: false,
        })
      })
  }

  onChangeRestaurant = selectedResto => {
    this.setState({ selectedResto }, () => {
      this.getRestaurantItems()
    })
  }

  onItemClick = itemKey => {
    const { selectedItems } = this.state

    if (_.includes(selectedItems, itemKey)) {
      this.setState({
        selectedItems: _.filter(selectedItems, oldItemKey => itemKey !== oldItemKey),
      })
    } else {
      this.setState({
        selectedItems: [...selectedItems, itemKey],
      })
    }
  }

  onSaveClick = () => {
    const confirm = window.confirm('Are you sure to save these recommended items?')

    if (confirm) {
      this.onSaveItems()
    }
  }

  onSaveItems = () => {
    const { selectedResto, selectedItems, recommendedBy, status } = this.state
    const { value: restKey } = selectedResto
    const self = this

    const updates = {}

    updates[`restaurants/${restKey}/show_recommend_items`] = {
      active: status === 'publish',
      recommended_by: recommendedBy,
    }

    _.map(selectedItems, itemKey => {
      updates[`restaurants/${restKey}/recommended_items/${itemKey}`] = true
    })

    this.setState({ saving: true })

    firebase
      .database()
      .ref()
      .update(updates)
      .then(err => {
        if (err) {
          alert(err)
          self.setState({ saving: false })
        } else {
          self.setState({ saving: false }, () => {
            self.props.history.push({
              pathname: `/advertisement`,
            })
          })
        }
      })
  }

  shouldDisabled = () => {
    const { selectedResto, selectedItems } = this.state

    if (selectedResto === null) {
      return true
    }

    if (_.size(selectedItems) === 0) {
      return true
    }

    return false
  }

  generateDropDownRestaurants = () => {
    const { restaurants } = this.props
    const selectOptions = []

    _.map(restaurants, (restaurant, key) => {
      if (restaurant.status === 'publish') {
        selectOptions.push({
          value: key,
          label: restaurant.name,
        })
      }
    })

    return selectOptions
  }

  renderRow = item => {
    const { selectedItems } = this.state

    return (
      <Menu.Item
        key={item.itemKey}
        active={_.includes(selectedItems, item.itemKey)}
        onClick={() => this.onItemClick(item.itemKey)}
        style={{ padding: '13px 10px', borderRadius: 0 }}
      >
        <div
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <div
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              lineHeight: '1.3',
              display: 'flex',
              flex: 1,
              fontSize: 15,
            }}
          >
            {item.name}
            <Label style={{ marginLeft: 8 }}>${item.current_price}</Label>
          </div>
          {_.includes(selectedItems, item.itemKey) && (
            <div
              style={{
                display: 'flex',
                width: 20,
                justifyContent: 'flex-end',
                marginLeft: 5,
              }}
            >
              <Icon name="check" color="green" />
            </div>
          )}
        </div>
      </Menu.Item>
    )
  }

  renderSelectedRow = item => {
    return (
      <Menu.Item key={item.itemKey} style={{ padding: '13px 10px', borderRadius: 0 }}>
        <div
          style={{
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex',
          }}
        >
          <div
            style={{
              whiteSpace: 'normal',
              wordBreak: 'break-all',
              lineHeight: '1.3',
              display: 'flex',
              flex: 1,
              fontSize: 15,
            }}
          >
            {item.name}
            <Label style={{ marginLeft: 8 }}>${item.current_price}</Label>
          </div>
        </div>
      </Menu.Item>
    )
  }

  renderItems = () => {
    const { items, selectedResto, searchValue } = this.state

    if (selectedResto === null) {
      return null
    }

    let itemsToDisplay = items[selectedResto.value]

    itemsToDisplay = _.filter(
      _.map(itemsToDisplay, (item, itemKey) => ({ ...item, itemKey })),
      item => item.name.toLowerCase().search(searchValue) !== -1
    )

    return (
      <Menu vertical style={{ maxHeight: 'calc(100vh - 430px)', overflow: 'auto', width: '100%' }}>
        <Menu.Item key="header" header style={{ padding: 10 }}>
          <div
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <div style={{ display: 'flex', flex: 1 }}>List of Items</div>
            <div style={{ display: 'flex' }}>
              <Input
                type="text"
                placeholder="Search"
                name="search-driver"
                onChange={e =>
                  this.setState({
                    searchValue: e.target.value.toLowerCase().trim(),
                  })
                }
                icon="search"
                style={{ height: 30, width: 200 }}
              />
            </div>
          </div>
        </Menu.Item>
        {_.map(itemsToDisplay, item => {
          return this.renderRow(item)
        })}
      </Menu>
    )
  }

  renderSelectedItem = () => {
    const { items, selectedResto, selectedItems } = this.state

    if (selectedResto === null) {
      return null
    }

    let itemsToDisplay = items[selectedResto.value]

    itemsToDisplay = _.filter(itemsToDisplay, (item, itemKey) => _.includes(selectedItems, itemKey))

    return (
      <Menu vertical style={{ maxHeight: 'calc(100vh - 430px)', overflow: 'auto', width: '100%' }}>
        <Menu.Item key="header" header style={{ padding: 10 }}>
          <div
            style={{
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              display: 'flex',
            }}
          >
            <div style={{ display: 'flex', flex: 1 }}>List of Items</div>
          </div>
        </Menu.Item>
        {_.map(itemsToDisplay, item => {
          return this.renderSelectedRow(item)
        })}
      </Menu>
    )
  }

  render() {
    const { history, restaurantLoading } = this.props
    const { selectedResto, status, itemsLoading, selectedItems, recommendedBy, saving } = this.state

    const label =
      history.location.state &&
      history.location.state.action &&
      history.location.state.action === 'edit'
        ? 'Edit Recommended'
        : 'New Recommended'
    const btnLabel =
      history.location.state &&
      history.location.state.action &&
      history.location.state.action === 'edit'
        ? 'Update'
        : 'Save'

    return (
      <div>
        <Segment color="black">
          <Header size="large">
            {label}
            <Button
              style={{ float: 'right' }}
              color="black"
              disabled={saving || this.shouldDisabled()}
              onClick={this.onSaveClick}
              loading={saving}
            >
              {btnLabel}
            </Button>
          </Header>
          <Form loading={restaurantLoading}>
            <Grid columns={2}>
              <Grid.Row>
                <Grid.Column>
                  <Form.Field required>
                    <label>Restaurant</label>
                    <Select
                      className="basic-single"
                      classNamePrefix="select"
                      isDisabled={
                        history.location.state &&
                        history.location.state.action &&
                        history.location.state.action === 'edit'
                      }
                      isRtl={false}
                      isSearchable
                      name="restaurant"
                      options={this.generateDropDownRestaurants()}
                      value={selectedResto}
                      onChange={this.onChangeRestaurant}
                    />
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ paddingTop: 0 }}>
                <Grid.Column>
                  {selectedResto !== null && (
                    <div>
                      <div>Restaurant Items</div>
                      <Loader active={itemsLoading} />
                      <div style={{ marginTop: 10 }}>{this.renderItems()}</div>
                    </div>
                  )}
                </Grid.Column>
                <Grid.Column>
                  {selectedResto !== null && _.size(selectedItems) > 0 && (
                    <div>
                      <div>
                        Selected Items&nbsp;
                        {_.size(selectedItems) > 0 && `(${_.size(selectedItems)}) Selected`}
                      </div>
                      <div style={{ marginTop: 10 }}>{this.renderSelectedItem()}</div>
                    </div>
                  )}
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ paddingTop: 0 }}>
                <Grid.Column>
                  <Form.Field>
                    <label>Recommended By</label>
                    <Button
                      color="black"
                      basic={recommendedBy !== 'editor'}
                      disabled={saving}
                      onClick={() => this.setState({ recommendedBy: 'editor' })}
                    >
                      Editor
                    </Button>
                    <Button
                      color="black"
                      basic={recommendedBy !== 'resto'}
                      disabled={saving}
                      onClick={() => this.setState({ recommendedBy: 'resto' })}
                    >
                      Restaurant
                    </Button>
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row style={{ paddingTop: 0 }}>
                <Grid.Column>
                  <Form.Field>
                    <label>Status</label>
                    <Button
                      color="black"
                      basic={status !== 'publish'}
                      disabled={saving}
                      onClick={() => this.setState({ status: 'publish' })}
                    >
                      Publish
                    </Button>
                    <Button
                      color="black"
                      basic={status !== 'draft'}
                      disabled={saving}
                      onClick={() => this.setState({ status: 'draft' })}
                    >
                      Draft
                    </Button>
                  </Form.Field>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Form>
        </Segment>
      </div>
    )
  }
}

const mapStateToProps = ({ restaurants }) => ({
  restaurants: restaurants.data,
  restaurantLoading: restaurants.loading,
  restaurantLoaded: restaurants.loaded,
})

const mapDispatchToProps = dispatch => ({
  fetchRestaurants: () => dispatch(RestaurantActions.fetchRestaurantsRequest()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NewRecommended)



// WEBPACK FOOTER //
// ./src/containers/advertisement/newRecommended.js